export class ConstantsSonstige {
  //
  static readonly PROGRAMM_START_YEAR: number = 2023;
  static readonly PROGRAM_NAME: string = 'bwa-web';
  static readonly PROGRAM_VERSION: string = '1.02';
  static readonly PROGRAM_IS_ENTWICKLUNG: boolean = false;
  static readonly PROGRAM_LOG_PROOGRAM_EBENE: string = 'WEB';
  //

  static readonly CSV_ANZAHL: number = 3;
  static readonly MAX_BETRIEBE_ANZEIGEN: number = 3;

  static readonly FILENAME_ZIP: string = 'klassifizierungen';

  static readonly FILENAME_VERORDNUNG: string =
    'Durchführungsverordnung (EU) 2019_1975';
  static readonly FILENAME_BETRIEBSGROESSENKLASSEN: string =
    'Durchführungsverordnung 2015_220';
  static readonly FILENAME_NUTS_ZWEI_REGIONEN: string = 'NUTS-2 Regionen 2022';
}
